import { render } from "./mItemDetail.vue?vue&type=template&id=66a604ac&scoped=true"
import script from "./mItemDetail.vue?vue&type=script&lang=js"
export * from "./mItemDetail.vue?vue&type=script&lang=js"

import "./mItemDetail.vue?vue&type=style&index=0&id=66a604ac&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a604ac"]])

export default __exports__